import assert = require("assert");
import { ringsInfoList } from "./rings_config";

describe("protocol-simulator", () => {

  it("simulate and report", () => {

    assert(true, "true");
  });

});
